const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

const padNumber = (value) => String(value).padStart(2, '0');

export const toCalendarDateString = (value) => {
  if (!value) return '';

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return '';

    const dateOnlyMatch = trimmed.match(DATE_ONLY_PATTERN);
    if (dateOnlyMatch) {
      return `${dateOnlyMatch[1]}-${dateOnlyMatch[2]}-${dateOnlyMatch[3]}`;
    }
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }

  return [
    parsed.getFullYear(),
    padNumber(parsed.getMonth() + 1),
    padNumber(parsed.getDate()),
  ].join('-');
};

export const calendarDateToLocalDate = (value) => {
  const normalized = toCalendarDateString(value);
  if (!normalized) {
    return null;
  }

  const [yearRaw, monthRaw, dayRaw] = normalized.split('-');
  const year = Number(yearRaw);
  const month = Number(monthRaw);
  const day = Number(dayRaw);
  const parsed = new Date(year, month - 1, day);

  if (
    Number.isNaN(parsed.getTime()) ||
    parsed.getFullYear() !== year ||
    parsed.getMonth() !== month - 1 ||
    parsed.getDate() !== day
  ) {
    return null;
  }

  return parsed;
};

export const formatCalendarDate = (value, locale = 'en-US', options = {}) => {
  const parsed = calendarDateToLocalDate(value);
  return parsed ? parsed.toLocaleDateString(locale, options) : '';
};
